import { PublicClientApplication } from '@azure/msal-browser';


const msalConfig = {
  
  auth: {
    // "94419d9e-40f7-4eee-877a-548a2654b6da" - PRODUÇÃO BELGICA
    // "abee6489-9be5-4de6-8860-d68bf08f9158"- TESTEHUB NO BRASIL 
    clientId: "a067c8c9-f977-4d43-a0f1-d583fe57c98d",
    authority: "https://login.microsoftonline.com/common",
    redirectUri:
      window.location.hostname === 'localhost'
        ? "http://localhost:3000/login"
        : window.location.hostname === 'dev-iris-tpf.azurewebsites.net'
          ? "https://dev-iris-tpf.azurewebsites.net/login"
          : window.location.hostname === 'prod-iris-tpf.azurewebsites.net'
            ? "https://prod-iris-tpf.azurewebsites.net/login"
            : window.location.hostname === 'iris.tpf.be'
              ? "https://iris.tpf.be/login"
              : "https://test-iris-tpf.azurewebsites.net/login"
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (level === 'error') {
          console.error(message);
        } else if (level === 'verbose') {
          console.debug(message)
        } else if (level === 'warning') {
          console.warn(message);
        }
      },
      piiLoggingEnabled: false,
      logLevel: 'info',
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize().catch((err) => console.error("Erro ao inicializar MSAL:", err));
export const loginRequest = {
  scopes: ["User.Read"],
};